module.exports = "./images/15_shopvise.jpg";